import { useEffect, useState } from 'react'
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom'
import PersonIcon from '@mui/icons-material/Person'
import SendRoundedIcon from '@mui/icons-material/SendRounded'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material'

export default function CheckinRequestPromptDialog({
  open,
  roomData,
  clinicLocationData,
  onClose,
  onSubmit,
  loading = false,
}) {
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (!open) {
      setReason('')
    }
  }, [open])

  const occupantName = roomData?.checkedInMentorName || 'the current mentor'
  const roomLabel = roomData?.title || roomData?.chamberRoomTitle || 'Chamber room'
  const locationLabel =
    clinicLocationData?.name || roomData?.clinicLocationName || 'Clinic location'
  const brandLabel =
    clinicLocationData?.clinicBrandName || roomData?.clinicBrandName || 'Clinic brand'

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Request Checkout
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: '12px !important' }}>
        <Box sx={{ display: 'grid', gap: 2 }}>
          <Box
            sx={{
              borderRadius: 2.5,
              border: '1px solid rgba(37, 99, 235, 0.12)',
              background:
                'linear-gradient(135deg, rgba(37, 99, 235, 0.08) 0%, rgba(255, 255, 255, 0.98) 100%)',
              p: 2,
              display: 'grid',
              gap: 1.25,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PersonIcon sx={{ color: 'rgba(37, 99, 235, 0.92)', fontSize: 20 }} />
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Current occupant
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 700, color: 'text.primary' }}>
                {occupantName}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <MeetingRoomIcon sx={{ color: 'rgba(37, 99, 235, 0.92)', fontSize: 20 }} />
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {brandLabel} {'>'} {locationLabel} {'>'} {roomLabel}
              </Typography>
            </Box>
          </Box>

          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            The checked-in mentor will be asked to check out. If they do not respond in 2 minutes,
            a checkout countdown will begin automatically.
          </Typography>

          <TextField
            label="Optional note"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            placeholder="Add any context for why you need this room."
            multiline
            minRows={3}
            fullWidth
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          disabled={loading}
          sx={{ textTransform: 'none', borderRadius: '999px' }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => onSubmit?.(reason?.trim())}
          variant="contained"
          disabled={loading}
          startIcon={<SendRoundedIcon />}
          sx={{ textTransform: 'none', borderRadius: '999px', px: 2.25 }}
        >
          {loading ? 'Sending request...' : 'Send request'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
